import { Grid, ListItem, Button } from '@material-ui/core'
import EditIcon from '@mui/icons-material/Edit';
import React from 'react'
import { showText } from '../../helpers/textValidation';

const ListItemResult = (props) => {
    const { data } = props
    const mainData = data

    const ShowData = ({ data }) => {
        let { head, span, visibility, showButton, onClick, text } = data;
        return (<>
            {(visibility !== false && visibility) &&
                <ListItem container className="p0 pt6 pb20">
                    <Grid xs={12} className="bold">
                        {head}
                        {span !== false && <span style={{ fontSize: '12px', fontWeight: 'lighter' }}>{span}</span>}
                        {(showButton !== false && showButton) &&
                            <Button>
                                <EditIcon onClick={onClick} />
                            </Button>
                        }
                    </Grid>
                    <Grid xs={12}>{showText(text)}</Grid>
                </ListItem>}
        </>)
    }
    return (
        <>
            {mainData?.map(cvalue => (<ShowData data={cvalue} />))}
        </>
    )

}

export default ListItemResult